import { OrderStatuses } from 'constants/orderStatuses';

import { styled } from '@mui/material/styles';
import { ChipField } from 'react-admin';

export const ConfirmationChipField = styled(ChipField)(({ theme }) => ({
  backgroundColor: theme.palette.status.orderStatus[OrderStatuses.WaitingConfirmation],
  color: theme.palette.background.default,
  margin: '0 !important',
  height: '24px',
}));

export const OrderStatusChipFieldStyled = styled(ChipField)({
  margin: '0 !important',
  height: '24px',
});
